import { formatDateKanji } from '@/util/common'
import * as moment from 'moment'

export const ServiceLicenseCancelInputConfirm = (props, context) => {
  const store = context.root.$store
  const { cancellation: { cancellationList } } = store.state

  const close = () => {
    context.emit('closeViewConfirm')
  }
  const openViewComplete = () => {
    context.emit('openViewComplete')
  }

  // ライセンス終了日の翌日を算出
  const endDate = (date) => {
    return formatDateKanji(moment(date).add(1, 'days'))
  }

  return {
    close,
    openViewComplete,
    cancellationList,
    formatDateKanji,
    endDate
  }
}
